import { useQueryParams } from "../../../hooks/useQueryParams";
import type { IOption } from "../../StyledSelect/StyledSelect";
import { StyledSelect } from "../../StyledSelect/StyledSelect";

const options: IOption[] = [
  {
    value: "",
    label: "All statuses",
  },
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "accepted",
    label: "Accepted",
  },
  {
    value: "revoked",
    label: "Revoked",
  },
];

const FilterByInvitationStatus = () => {
  const { queryValue, handleChange } = useQueryParams({
    queryStr: "status",
  });

  return (
    <div className="w-full d-flex flex-column mb-2 card-toolbar custom-filter-wrapper custom-filter-wrapper--flexible">
      <StyledSelect
        options={options}
        isClearable={queryValue ? queryValue !== options[0].value : false}
        isDisabled={false}
        isLoading={false}
        isSearchable={false}
        onChange={e => {
          handleChange(e?.value || "", true);
        }}
        value={
          queryValue
            ? options.find(option => option.value === queryValue)
            : options[0]
        }
      />
      <div className="short-explanation w-100">
        <strong>Filter</strong> by status
      </div>
    </div>
  );
};

export { FilterByInvitationStatus };
